import z from 'zod';
import { SideSchema } from './common';

export const LogicNodeInstanceDtoSchema = z.object({
  id: z.string(),
  type: z.string(),
  state: z.unknown(),
  output: z.boolean(),
  runtimeKey: z.string().optional(),
});

export const LogicEdgeDtoSchema = z.object({
  id: z.string(),
  sourceNodeId: z.string(),
  targetNodeId: z.string(),
  meta: z
    .object({
      sourceTileId: z.string().optional(),
      targetTileId: z.string().optional(),
      targetSide: SideSchema.optional(),
    })
    .optional(),
});

export const LogicGraphDtoSchema = z.object({
  nodes: z.array(LogicNodeInstanceDtoSchema),
  edges: z.array(LogicEdgeDtoSchema),
});

export type LogicNodeInstanceDto = z.infer<typeof LogicNodeInstanceDtoSchema>;

export type LogicEdgeDto = z.infer<typeof LogicEdgeDtoSchema>;
export interface LogicEdge extends Omit<LogicEdgeDto, 'id' | 'sourceNodeId' | 'targetNodeId'> {
  id: import('@/models/logic/RuntimeHandles').EdgeHandle;
  sourceNodeId: import('@/models/logic/RuntimeHandles').NodeHandle;
  targetNodeId: import('@/models/logic/RuntimeHandles').NodeHandle;
  /** Only imported v1 edges retain an opaque external spelling. */
  externalId?: string;
}

export type LogicGraphDto = z.infer<typeof LogicGraphDtoSchema>;
